import { getRandomInt } from '@/utilities';
import Task from '@/models/Task';
import Wireframe from '@/models/Task/Wireframe';

export default class Story extends Task {
  constructor({ product, parentTask }) {
    super({ product, parentTask });
    this.remainingTime = this.getBaseTime();
  }

  // Phase 2 要看原本由哪個 Team 處理
  // eslint-disable-next-line class-methods-use-this
  getBaseTime() {
    return getRandomInt(1, 3);
  }

  // 先假設所有 Team 都有
  // Phase 2 要考慮 teamType
  generateSubTasks() {
    return super.generateTasks({
      TypeClass: Wireframe,
      product: this.product,
      count: getRandomInt(1, 5),
    });
  }
}
